import { FormStepGroupType } from "../../types";
import { states } from "../../options/states";

export const emergencyContactGroup: FormStepGroupType = {
  name: "emergency-contact",
  title: "Emergency Contact",
  subTitle: "Adding a contact helps if there's an issue with your application.",
  collapsible: true,
  optional: true,
  hasSeparationLine: true,
  class: "group--emergencyContact",
  fields: [
    {
      component: "TextInput",
      name: "emergencyName",
      label: "Full Name",
      type: "text",
      placeholder: "",
      maxLength: 45,
      validation: {
        maxLength: 45,
        minLength: {
          value: 2,
          message: "The full name must have at least two characters.",
        },
      },
      cols: 6,
      uniqueRow: true,
    },
    {
      component: "TextInput",
      name: "emergencyAddress1",
      label: "Street Address / RFD# Or P.O. Box",
      type: "text",
      placeholder: "",
      maxLength: 35,
      validation: {
        maxLength: 35,
        minLength: {
          value: 2,
          message: "The Street Address / RFD# Or P.O. Box must have at least two characters.",
        },
      },
      cols: 6,
    },
    {
      component: "TextInput",
      name: "emergencyAddress2",
      label: "Apartment, Company, Suite... (Optional)",
      type: "text",
      placeholder: "",
      maxLength: 6,
      validation: {
        maxLength: {
          value: 6,
          message: "The apartment, company, suite... must have maximum six characters.",
        },
        minLength: {
          value: 2,
          message: "The apartment, company, suite... must have at least two characters.",
        },
      },
      cols: 6,
    },
    {
      component: "TextInput",
      name: "emergencyCity",
      label: "City",
      type: "text",
      placeholder: "",
      maxLength: 27,
      validation: {
        maxLength: 27,
        minLength: {
          value: 2,
          message: "The city must have at least two characters.",
        },
      },
      cols: 4,
    },
    {
      component: "Select",
      name: "emergencyStateTerritory",
      label: "State",
      type: "select",
      placeholder: "Select a State",
      validation: {},
      cols: 4,
      options: states,
    },
    {
      component: "TextInput",
      name: "emergencyZipCode",
      label: "Zip Code",
      type: "text",
      placeholder: "",
      cols: 4,
      maxLength: 9,
      validation: {
        maxLength: 9,
      },
    },
    {
      component: "TextInput",
      name: "emergencyPhone",
      label: "Telephone Number",
      type: "tel",
      mask: "999999999999999",
      validation: {},
      cols: 6,
    },
    {
      component: "TextInput",
      name: "relationship",
      label: "Relationship",
      type: "text",
      placeholder: "",
      maxLength: 18,
      validation: {
        maxLength: 18,
        minLength: {
          value: 2,
          message: "The relationship must have at least two characters.",
        },
      },
      cols: 6,
      tooltip: "Please describe your relationship with your emergency contact.",
    },
  ],
};
